<script>
  import { apiFetch } from "../lib/api.js";
  import { user } from "../stores/user";
  import Navbar from "../components/Navbar.svelte";
  import CardContent from "../components/CardContent.svelte";
  import { BASE_URL } from "../stores/BASE_URL";
  import getFecha from "../services/fecha";
  import { onMount } from "svelte";
  import { navigate } from "svelte-routing";
  import Spinner from "../components/Spinner.svelte";
  import SinInformacion from "../components/Sin_informacion.svelte";

  let inicio = getFecha();
  let fin = getFecha();
  let isLoading = false;

  const getAcciones = async () => {
    isLoading = true;
    const response = await apiFetch(`${BASE_URL}accion.php?inicio=${inicio}&fin=${fin}`);
    const resp = await response.json();
    isLoading = false;
    return resp;
  };

  let acciones = getAcciones();

  const buscar = () => {
    acciones = getAcciones();
  };

  onMount(() => {
    if (!$user) {
      navigate("/", { replace: true });
    }

    if (!$user.rol == "administrador" && !$user.rol == "operaciones") {
      navigate("/", { replace: true });
    }
  });
</script>

{#if $user}
  <Navbar />

  <div class="container-fluid py-3">
    <CardContent title="Acciones">
      <div class="row g-2 align-items-center mb-2">
        <div class="col-auto">
          <input type="date" class="form-control" bind:value={inicio} />
        </div>
        <div class="col-auto">
          <input type="date" class="form-control" bind:value={fin} />
        </div>
        <div class="col-auto">
          {#if isLoading}
            <button class="btn btn-primary" type="button" disabled>
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
              Cargando...
            </button>
          {:else}
            <button class="btn btn-primary" on:click={buscar}>Buscar</button>
          {/if}
        </div>
      </div>
      <div>
        {#await acciones}
          <Spinner message="Cargando" />
        {:then response}
          <div class="table-responsive">
            <table class="table table-sm table-striped table-bordered small">
              <thead>
                <tr class="text-secondary fw-normal">
                  <th>Usuario</th>
                  <th>Acción</th>
                  <th>Fecha</th>
                </tr>
              </thead>
              <tbody>
                {#each response as accion}
                  <tr>
                    <td>{accion.usuario}</td>
                    <td>{accion.accion}</td>
                    <td>{accion.fecha}</td>
                  </tr>
                {:else}
                  <tr>
                    <td colspan="3">
                      <SinInformacion message="Sin información  " />
                    </td>
                  </tr>
                {/each}
              </tbody>
            </table>
          </div>
        {/await}
      </div>
    </CardContent>
  </div>
{/if}
